import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Filter from './Filter';
import { useEffect, useState } from 'react';
import { isLogin } from '../../utils/auth';
import { useModal } from '../../context/ModalContext';
import SearchService from '../../service/search/Search';
import QuickSearchResult from '../components/quickSearch/QuickSearchResult';
import { ISearchList } from '../../service/auction/AuctionList';

interface SearchDataProps {
  iidx: number;
  type: string;
  caseno: string;
  unitno: string;
  court: string;
  iaddr: string;
  lat: number;
  lng: number;
  group_category: string;
  status: string;
  addr: string;
  category: string;
}

interface Props {
  isModal?: boolean;
  onClose?: () => void;
}

function QuickSearch({ isModal, onClose }: Props) {
  const navigate = useNavigate();
  const { modalDispatch } = useModal();

  const [value, setValue] = useState('');
  const [isFocus, setIsFocus] = useState(false);
  const [list, setList] = useState<SearchDataProps[]>([]);

  const handleClick = (item: ISearchList) => {
    if (!isLogin()) {
      modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
      return;
    }

    const pathObj = {
      a: '/auction/detail/',
      p: '/pauction/detail/',
      e: '/scheduled/detail/',
    };
    const url = pathObj[item.type as 'a' | 'p' | 'e'] + item.iidx;

    setValue('');
    setIsFocus(false);
    setList([]);
    window.open(url, '_blank');
  };

  const getList = async (value: string) => {
    try {
      const res = await SearchService.search(value);
      setList(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  // useEffect(() => {
  //   if (value !== '') {
  //     if (!isLogin()) {
  //       return;
  //     }
  //     getList(value);
  //   }
  //   if (value === '') {
  //     setList([]);
  //   }
  // }, [value]);

  return (
    <Container>
      <QuickSearchSection>
        <InputWrapper $focus={isFocus}>
          <img src="/assets/images/icon/search-gray.svg" alt="search" />
          <TextInput
            type="text"
            placeholder="사건번호・상세주소 검색"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onFocus={() => setIsFocus(true)}
            onBlur={() => setIsFocus(false)}
          />
          {value && (
            <img
              src="/assets/images/close/close-circle.svg"
              alt="clear"
              onClick={() => setValue('')}
            />
          )}
          {isFocus && (
            <QuickSearchResult
              value={value}
              yPosition={50}
              onClickItem={handleClick}
            />
          )}
        </InputWrapper>
        <CancleButton
          onClick={() => {
            if (isModal && onClose) {
              onClose();
            } else {
              navigate(-1);
            }
          }}
        >
          취소
        </CancleButton>
      </QuickSearchSection>
      <Filter />
    </Container>
  );
}

export default QuickSearch;

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;

  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  background-color: #fff;
`;

const QuickSearchSection = styled.div`
  display: flex;
  width: 100%;
  padding: 10px 6px 6px 16px;
  align-items: center;
  gap: 8px;
  background-color: #fff;
`;

const InputWrapper = styled.div<{ $focus?: boolean }>`
  position: relative;
  display: flex;
  padding: 10px 14px;
  align-items: center;
  gap: 6px;

  flex: 1 1 auto;
  min-width: 0;

  border-radius: 8px;
  background: #f5f6f7;

  /* box-sizing: border-box; */
  /* border: 1px solid transparent; */

  ${({ $focus }) =>
    $focus
      ? `box-shadow: 0 0 0 1px #008AFF;`
      : `box-shadow: 0 0 0 1px #f5f6f7;`}
`;

const TextInput = styled.input`
  min-width: 0;
  flex: 1 1 0;

  color: rgba(0, 12, 30, 0.8);
  background: transparent;
  border: none;
  outline: none;

  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;

  &::placeholder {
    color: #6b7684;
  }
`;

const CancleButton = styled.div`
  display: flex;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  color: rgba(0, 12, 30, 0.8);
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const AutoComplete = styled.ul`
  position: absolute;
  right: 0;
  left: 0;
  top: 35px;

  z-index: 9999;
  box-sizing: border-box;
  max-height: 400px;
  overflow-y: auto;

  background: #fff;
  border: 1px solid #b9b8b8;
  border-radius: 10px;
  box-shadow: 1px 2px 3px 0px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  padding: 0;

  font-size: 14px;
  font-weight: 500;

  li {
    width: 100%;
    padding: 10px;
    border-bottom: solid 1px #b9b8b8;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 8px;

    &:hover {
      background-color: rgb(255, 254, 223);
    }

    &.no-hover {
      &:hover {
        background-color: transparent;
      }
    }

    div {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

    div > div:first-child {
      flex: 6;
    }

    div > div:nth-child(2) {
      flex: 4;
      justify-content: flex-end;
    }
  }

  :last-child {
    border-bottom: none;
  }
`;

const AutoCompleteText = styled.div<{ color?: string }>`
  display: inline-block;
  min-width: 0;
  font-size: 12px;
  font-weight: 500;
  color: ${(props) => props.color};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const AuctionType = styled.div<{ type: string }>`
  justify-content: flex-end;
  padding: 2px 8px;
  border-radius: 999px;
  max-width: fit-content;
  font-size: 12px;
  background-color: ${(props) =>
    (props.type === 'a' && 'rgb(255, 219, 214)') ||
    (props.type === 'p' && 'rgb(222, 237, 255)') ||
    (props.type === 'e' && '#fffce3')};
  color: ${(props) =>
    (props.type === 'a' && 'rgb(216, 72, 54)') ||
    (props.type === 'p' && 'rgb(12, 100, 206)') ||
    (props.type === 'e' && '#d87300')};
  font-weight: 500;
`;

const StatusBadge = styled.div`
  justify-content: flex-end;
  padding: 2px 8px;
  border-radius: 999px;
  max-width: fit-content;
  font-size: 12px;
  background-color: #70737c14;
  color: #37383c9c;
  font-weight: 500;
`;
